import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import capitalizeFirstLetter from 'intergalactic/utils/lib/capitalizeFirstLetter';
var MAP_OFFSET = {
  top: 'width',
  bottom: 'width',
  left: 'height',
  right: 'height'
};
var MAP_COORDINATE = {
  width: 'x',
  height: 'y'
};
function isEmpty(obj) {
  return !Object.keys(obj).length;
}
function arrowOffset(_ref) {
  var _state$options$modifi;
  var state = _ref.state;
  if (isEmpty(state.modifiersData['arrow']) || isEmpty(state.modifiersData['popperOffsets'])) return;
  var _state$placement$spli = state.placement.split('-'),
    _state$placement$spli2 = _slicedToArray(_state$placement$spli, 2),
    position = _state$placement$spli2[0],
    align = _state$placement$spli2[1];
  var offset = MAP_OFFSET[position];
  var coordinate = MAP_COORDINATE[offset];
  var padding = ((_state$options$modifi = state.options.modifiers.find(function (mod) {
    return mod.name === 'arrow';
  })) === null || _state$options$modifi === void 0 ? void 0 : _state$options$modifi.options.padding) || 0;
  if (align === 'start') {
    var lenRef = state.rects.reference[offset];
    state.modifiersData.arrow[coordinate] = padding;
    if (lenRef / 2 < padding) {
      var lenArrow = state.elements.arrow["offset".concat(capitalizeFirstLetter(offset))];
      var offsetArrow = lenArrow / 2 + padding - lenRef / 2 + 0.5;
      state.modifiersData.popperOffsets[coordinate] -= offsetArrow;
    }
  }
  if (align === 'end') {
    var _lenRef = state.rects.reference[offset];
    var lenPopper = state.rects.popper[offset];
    var _lenArrow = state.elements.arrow["offset".concat(capitalizeFirstLetter(offset))];
    state.modifiersData.arrow[coordinate] = lenPopper - _lenArrow - padding;
    if (_lenRef / 2 < padding) {
      var _offsetArrow = _lenArrow / 2 + padding - _lenRef / 2;
      state.modifiersData.popperOffsets[coordinate] += _offsetArrow;
    }
  }
}
var ArrowOffsetModifier = {
  name: 'arrowOffset',
  enabled: true,
  phase: 'main',
  fn: arrowOffset,
  requires: ['arrow', 'popperOffsets'],
  requiresIfExists: ['arrow']
};
export default ArrowOffsetModifier;
//# sourceMappingURL=arrowOffset.js.map